export default __webpack_public_path__ + "fa1825530fb455531b86e7769d307547.png";